import { Provider } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faChartLine, faChartPie, faUserGraduate, faChalkboardTeacher, faCalendarAlt, faCogs, faBookOpen, faTasks } from '@fortawesome/free-solid-svg-icons';

import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Main styles for this application
import '../scss/style.scss';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';


// app
import App from './App';
// Configure Store
import configure from './configurestore';

library.add(fab, faChartLine, faUserGraduate, faChalkboardTeacher, faCalendarAlt, faChartPie, faCogs, faBookOpen, faTasks);
// Initiate store
const initialState = {

};

const store = configure(initialState);
ReactDOM.render(
  (
    <Provider store={store}>
      <App />
    </Provider>
  ), document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js